import { trackEvent } from './trackhome'

const EVENT = 'traffic-lookup'

function track(fetcherName, step, tags = [], value) {
  if (!fetcherName) return
  trackEvent(EVENT, [`step:${step}`, `fetcher:${fetcherName}`, ...tags], value)
}

function normalizeReason(reason) {
  if (!reason) return 'other'
  const normalized = String(reason).toLowerCase()
  if (normalized.includes('declin')) return 'declined'
  if (normalized.includes('validation')) return 'validation'
  if (normalized.includes('login')) return 'login_required'
  if (normalized.includes('user_create') || normalized.includes('registered')) {
    return 'user_create'
  }
  if (normalized.includes('charge') || normalized.includes('payment')) {
    return 'payment'
  }
  return 'other'
}

export function landing(fetcherName) {
  track(fetcherName, 'landing')
}

export function search(fetcherName) {
  track(fetcherName, 'search')
}

export function results(fetcherName, ticketCount) {
  track(
    fetcherName,
    'results',
    [`found:${ticketCount > 0 ? 'yes' : 'no'}`],
    ticketCount
  )
}

export function noResult(fetcherName) {
  track(fetcherName, 'no_result')
}

export function noResultView(fetcherName) {
  track(fetcherName, 'no_result_view')
}

export function manualSubmit(fetcherName) {
  track(fetcherName, 'manual_submit')
}

export function manualSubmitted(fetcherName) {
  track(fetcherName, 'manual_submitted')
}

export function manualSubmitFailure(fetcherName, reason) {
  track(fetcherName, 'manual_submit_failure', [`reason:${normalizeReason(reason)}`])
}

export function checkout(fetcherName) {
  track(fetcherName, 'checkout')
}

export function paid(fetcherName) {
  track(fetcherName, 'paid')
}

export function unpaid(fetcherName, reason) {
  track(fetcherName, 'unpaid', [`reason:${normalizeReason(reason)}`])
}
